import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function KitStockCreateMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.kit.stock.create(0));
  };

  return (
    <MainMenuItem
      itemTitleString="在庫を登録する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default KitStockCreateMenuItem;
